export function obsInThePastHelper(){
    return {
        obsInThePast(selectedObservations, numberOfDays){

            let today = new Date()
            let priorDate = isNaN(numberOfDays)
                ? new Date().setDate(today.getDate()-(today.getDate()-1))
                : new Date().setDate(today.getDate()-numberOfDays)

            return selectedObservations.filter(o => 
                priorDate <= new Date(o.MOTPDate).valueOf()
                && new Date(o.MOTPDate).valueOf() <= today.valueOf()
            ).length

        }

    }
}